import { drContact } from "@robisoft/cross-library";

export class GetContactsReq {
    myToken: string;
    store: string;
    province: string;
    region: string;
    pageNum: number;
    pageSize: number;

    constructor() {
        this.myToken = '';
        this.store = '';
        this.province = '';
        this.region = '';
        this.pageNum = 0;
        this.pageSize = 0;
    }
}

export class GetContactsResp {
    error: string;
    debug: string;
    contacts: drContact[];
    count: number;

    constructor() {
        this.error = '';
        this.debug = '';
        this.contacts = [];
        this.count = 0;
    }
}